<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <div id="particles-js" class="HomePage HomePageBG">
      <div class="HomePageOverlay"></div>
      <div class="HomePageShape">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
          <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
        </svg>
      </div>
    </div>
    <v-container fluid class="d-flex align-center justify-center" :style="{ height: `${useDisplaySize.height}px` }">
      <v-card :max-height="useDisplaySize.height / 1.3" :width="400" class="pa-3 pb-10 elevation-16">
        <v-row no-gutters>
          <v-col cols="12" align="center">
            <v-img class="imageClass" contain max-width="200px" src="@/assets/vozcare2.jpg" />
          </v-col>
          <v-col cols="12">
            <div class="text-center textVariant1 pt-4">Welcome back <span class="wave">👋</span></div>
          </v-col>
          <v-col cols="12">
            <v-window v-model="loginStepper" class="pl-0">
              <v-window-item :value="1">
                <v-card-text>
                  <v-form ref="formSignIn" @submit.prevent lazy-validation>
                    <v-text-field
                      flat
                      density="compact"
                      variant="outlined"
                      label="Email Address *"
                      class="textVariant3"
                      @keydown.space="preventLeadingSpace"
                      @keydown.enter="validateSignIn()"
                      prepend-inner-icon="mdi-account"
                      :rules="[(v) => !!v || 'Email Address is required']"
                      v-model="Login.EmailID"
                    ></v-text-field>
                    <v-text-field
                      flat
                      density="compact"
                      variant="outlined"
                      label="Password *"
                      class="textVariant3 mt-2"
                      :type="isPwdLogin ? 'text' : 'password'"
                      @click:append-inner="isPwdLogin = !isPwdLogin"
                      @keydown.space="preventLeadingSpace"
                      @keydown.enter="validateSignIn()"
                      required
                      :append-inner-icon="isPwdLogin ? 'mdi-eye' : 'mdi-eye-off'"
                      prepend-inner-icon="mdi-lock"
                      :rules="[(v) => !!v || 'Password is required']"
                      v-model="Login.Password"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions class="py-0">
                  <v-checkbox density="compact" class="my-0 py-0 ml-1" v-model="rememberme" label="Remember Me" :disabled="Login.EmailID === '' && Login.Password === ''" />
                  <v-spacer></v-spacer>
                  <v-btn class="fontSize mb-4" color="primaryVariant1 text-capitalize fontStyle" @click="loginStepper = 3"> Forgot Password? </v-btn>
                </v-card-actions>
                <v-card-actions class="px-4">
                  <v-btn block :loading="loading" variant="flat" class="borderRadius fontStyle" color="primaryVariant1" @click="validateSignIn()"> Sign In </v-btn>
                </v-card-actions>
              </v-window-item>

              <v-window-item :value="2">
                <v-card-text>
                  <v-form ref="formCP" lazy-validation>
                    <v-text-field
                      flat
                      density="compact"
                      variant="outlined"
                      class="textVariant3"
                      label="New Password *"
                      :type="isPwdNew ? 'text' : 'password'"
                      @click:append-inner="isPwdNew = !isPwdNew"
                      :append-inner-icon="isPwdNew ? 'mdi-eye' : 'mdi-eye-off'"
                      prepend-inner-icon="mdi-lock"
                      :rules="[(v) => !!v || 'New Password is required']"
                      v-model="Password.NewPassword"
                    ></v-text-field>
                    <v-text-field
                      flat
                      density="compact"
                      variant="outlined"
                      class="textVariant3"
                      label="Confirm Password *"
                      :type="isPwdConfirm ? 'text' : 'password'"
                      @click:append-inner="isPwdConfirm = !isPwdConfirm"
                      :append-inner-icon="isPwdConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                      prepend-inner-icon="mdi-lock"
                      :rules="[(v) => !!v || 'Confirm Password is required']"
                      v-model="Password.ConfirmPassword"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn variant="flat" block :loading="loading" class="borderRadius fontStyle" color="primaryVariant1" @click="ValidateConfirmPasswordForm()"> Confirm Password </v-btn>
                </v-card-actions>
                <div class="text-center">
                  <v-btn density="compact" variant="text" color="primaryVariant1" dark class="fontStyle borderRadius text-capitalize" small @click="loginStepper = 1"> Back to Sign In </v-btn>
                </div>
              </v-window-item>

              <v-window-item :value="3">
                <v-card-text>
                  <v-form ref="formResetPasswordSendOTP">
                    <div class="fontSize12px">Please enter your registered Email</div>
                    <v-text-field flat density="compact" variant="outlined" label="Email Address" v-model="ResetPassword.EmailID" :rules="[(v) => !!v || 'Email Address is required']" class="mt-4 borderRadius fontSize"></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn block :loading="loading" variant="flat" color="primaryVariant1" small @click="ValidateResetPassword()"> Next </v-btn>
                </v-card-actions>
                <div class="text-center">
                  <v-btn density="compact" variant="text" color="primaryVariant1" dark class="fontStyle borderRadius text-capitalize" small @click="loginStepper = 1"> Back to Sign In </v-btn>
                </div>
              </v-window-item>

              <v-window-item :value="4">
                <v-card-text>
                  <v-form ref="formConfirmOTP">
                    <div class="text-left fontSize12px">Enter the Vozcare Activation Code sent to your Email</div>
                    <v-text-field flat density="compact" variant="outlined" label="Activation Code *" v-model="ResetPassword.ActivationCode" :rules="[(v) => !!v || 'Activation Code is required']" class="mt-4 borderRadius"></v-text-field>
                    <v-text-field
                      flat
                      density="compact"
                      variant="outlined"
                      label="New Password *"
                      v-model="ResetPassword.Password"
                      :rules="[(v) => !!v || 'New Password is required']"
                      class="borderRadius fontSize"
                      :type="isPwdConfirmCode ? 'text' : 'password'"
                      @click:append-inner="isPwdConfirmCode = !isPwdConfirmCode"
                      :append-inner-icon="isPwdConfirmCode ? 'mdi-eye' : 'mdi-eye-off'"
                      prepend-inner-icon="mdi-lock"
                    ></v-text-field>
                    <v-text-field
                      flat
                      density="compact"
                      variant="outlined"
                      label="Confirm Password *"
                      v-model="ResetPassword.ConfirmPassword"
                      :rules="[(v) => !!v || 'Confirm Password is required']"
                      class="borderRadius fontSize"
                      :type="isPwdNewConfirmCode ? 'text' : 'password'"
                      @click:append-inner="isPwdNewConfirmCode = !isPwdNewConfirmCode"
                      :append-inner-icon="isPwdNewConfirmCode ? 'mdi-eye' : 'mdi-eye-off'"
                      prepend-inner-icon="mdi-lock"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn block :loading="loading" variant="flat" class="borderRadius fontStyle" color="primaryVariant1" @click="ValidateResetPasswordFinalMethod()"> Reset Password </v-btn>
                </v-card-actions>
                <div class="text-center">
                  <v-btn density="compact" variant="text" color="primaryVariant1" dark class="fontStyle borderRadius text-capitalize" small @click="loginStepper = 1"> Back to Sign In </v-btn>
                </div>
              </v-window-item>

              <v-window-item :value="5">
                <v-row no-gutters>
                  <v-col cols="12" align="center">
                    <v-img max-width="200px" src="@/assets/logout.gif" />
                  </v-col>
                  <v-col cols="12" align="center" class="pt-4">
                    <div class="fontSize12px">You have been logged out</div>
                  </v-col>
                  <v-col cols="12" align="center" class="pt-1">
                    <div class="textVariant5">Thank you for using <span class="font-weight-bold">Vozcare</span></div>
                  </v-col>
                  <v-col cols="12" align="center" class="pt-4">
                    <v-btn block variant="flat" color="#00bd9d" dark class="text-capitalize">Sign In</v-btn>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { BackgroundParticles } from "@/mixins/particle.js";
import Snackbar from "@/components/Extras/Snackbar.vue";

import { SignInAPI } from "@/mixins/RestAPI/SignInAPI.js";
import { ConfirmPasswordAPI } from "@/mixins/RestAPI/ConfirmPasswordAPI.js";
import { SendOTPConfirmPassword } from "@/mixins/RestAPI/SendOTPConfirmPassword.js";
import { ConfirmOTP } from "@/mixins/RestAPI/ConfirmOTP.js";
import { ResetExpiredPassword } from "@/mixins/RestAPI/ResetExpiredPassword.js";

import { cognitoAPIs } from "@/mixins/CognitoAPIs/cognitoAPIs.mjs";
export default {
  components: {
    Snackbar,
  },
  props: {
    useDisplaySize: Object,
  },
  mixins: [cognitoAPIs, SignInAPI, ConfirmPasswordAPI, ResetExpiredPassword, SendOTPConfirmPassword, ConfirmOTP, BackgroundParticles],
  data: () => ({
    loginStepper: 1,

    loading: false,
    isPwdNew: false,
    isPwdLogin: false,
    isPwdConfirm: false,
    isPwdConfirmCode: false,
    isPwdNewConfirmCode: false,
    rememberme: false,

    session: {},

    Login: {
      EmailID: "",
      Password: "",
    },
    Password: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    ResetPassword: {
      EmailID: "",
      ActivationCode: "",
      Password: "",
      ComfirmPassword: "",
    },

    sign_up: {
      user_name: "",
      user_email_id: "",
    },

    SnackBarComponent: {},
    countryCodeItems: [
      { country_name: "India", country_code: "+91" },
      { country_name: "USA", country_code: "+1" },
    ],
  }),
  watch: {
    model(val) {
      if (this.cardContent.length == val) {
        this.clearItervalMethod();
      }
    },
  },
  mounted() {
    this.initParticles();
    this.CheckRememberMe();
    this.disableHistoryChanges();
  },
  methods: {
    disableHistoryChanges() {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, "", window.location.href);
      };
    },
    validateSignUpMethod() {
      if (this.$refs.formSignUp.validate()) {
        this.signUpMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Invalid Input",
        };
      }
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ") e.target.value = e.target.value.replace(/^\s*/, "");
    },
    AddRememberMe() {
      if(this.rememberme == true){
        localStorage.setItem("currentuseremail",this.Login.EmailID);
        localStorage.setItem("currentuserpassword",this.Login.Password);
        localStorage.setItem("rememberme",this.rememberme);
      }
      else {
        localStorage.setItem("currentuseremail",null);
        localStorage.setItem("currentuserpassword",null);
        localStorage.setItem("rememberme",this.rememberme);
      }
    },
    CheckRememberMe() {
      if (localStorage.getItem("rememberme") == 'true') {
        this.Login.EmailID = localStorage.getItem("currentuseremail") ? localStorage.getItem("currentuseremail") : '';
        this.Login.Password = localStorage.getItem("currentuserpassword") ? localStorage.getItem("currentuserpassword") : '';
        this.rememberme = true;
      }
      
    },
  },
};
</script>

<style>
.HomePageBG {
  background-image: url("@/assets/bgImg.jpg") !important;
  background-position: center !important;
  background-size: cover !important;
}
.HomePageBG .HomePageOverlay {
  background-image: linear-gradient(to right, #f894a8, #000000) !important;
  opacity: 0.9 !important;
}
.HomePage {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 360px !important;
}
.HomePageOverlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
}
.HomePageShape {
  position: absolute !important;
  bottom: -10px !important;
  right: 0 !important;
  left: 0 !important;
  z-index: 0 !important;
  pointer-events: none !important;
}
.HomePageShape > svg {
  width: 100% !important;
  height: auto !important;
  fill: #fff !important;
}
</style>
